import React from 'react';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpText from '../ImpText/ImpText';
import styled from 'styled-components';
import ImpIcon from '../ImpIcon/ImpIcon';
import { colors } from '../../DesignSystem/colors';
import ImpFlexItem from '../../Atoms/ImpFlexItem/ImpFlexItem';
import { Icons } from '../../Icons/Icons';
const CIRCLE_SIZE = '24px';
const CIRCLE_BORDER_RADIUS = '12px';
const CONNECTOR_HEIGHT = '1px';
const COMPLETE_BACKGROUND_COLOR = 'var(--merchant-color)';
const INCOMPLETE_BACKGROUND_COLOR = colors.background.backgroundDisabled;
const COMPLETE_COLOR = 'white';
const INCOMPLETE_COLOR = colors.content.onBackground;
export const TRANSITION_DURATION_MS = 300;
export const TRANSITION_DURATION = '0.3s';
const CIRCLE_SIZE_SUBSTEP = '8px';
const ProgressBar = styled(ImpContainer) `
  background-color: ${INCOMPLETE_BACKGROUND_COLOR};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: ${CONNECTOR_HEIGHT};
    width: ${(props) => props.progressState === 'complete'
    ? '100%'
    : props.progressState === 'current'
        ? '50%'
        : '0%'};
    background-color: ${COMPLETE_BACKGROUND_COLOR};
    transition: width ${TRANSITION_DURATION};
    transition-delay: ${(props) => props.transitionDelay};
  }
`;
const Circle = styled(ImpContainer) `
  background-color: ${(props) => props.complete ? COMPLETE_BACKGROUND_COLOR : INCOMPLETE_BACKGROUND_COLOR};
  transition: background-color ${TRANSITION_DURATION} ${TRANSITION_DURATION};
`;
export default function ImpProgressBarItem({ label = 'X', labelIcon = undefined, state = 'incomplete', isEnd = false, isSubstep = false, transitionDelay = '0s', checkmarkOnComplete = false, }) {
    const content = () => {
        if (checkmarkOnComplete && state === 'complete') {
            return (React.createElement(ImpIcon, { iconSrc: Icons.checkmark, stroke: COMPLETE_COLOR, size: "16px", transition: `stroke ${TRANSITION_DURATION} ${TRANSITION_DURATION}` }));
        }
        if (labelIcon) {
            return (React.createElement(ImpIcon, { iconSrc: labelIcon, stroke: state === 'complete' || state === 'current'
                    ? COMPLETE_COLOR
                    : INCOMPLETE_COLOR, size: "16px", transition: `stroke ${TRANSITION_DURATION} ${TRANSITION_DURATION}` }));
        }
        else {
            return (React.createElement(ImpText, { typography: "body3", color: state === 'complete' || state === 'current'
                    ? COMPLETE_COLOR
                    : INCOMPLETE_COLOR, transition: `color ${TRANSITION_DURATION} ${TRANSITION_DURATION}` }, label));
        }
    };
    return (React.createElement(ImpFlex, { direction: "row", align: "center", dataTestId: "progress-bar-item-flex", fluid: true },
        React.createElement(ImpFlexItem, { flexGrow: 0 },
            React.createElement(Circle, { complete: state === 'complete' || state === 'current', height: isSubstep ? CIRCLE_SIZE_SUBSTEP : CIRCLE_SIZE, width: isSubstep ? CIRCLE_SIZE_SUBSTEP : CIRCLE_SIZE, borderRadius: CIRCLE_BORDER_RADIUS, dataTestId: "checkpoint", backgroundColor: "green" }, !isSubstep && (React.createElement(ImpFlex, { fluid: true, align: "center", justify: "center" }, content())))),
        !isEnd && (React.createElement(ImpFlexItem, { flexGrow: 1 },
            React.createElement(ProgressBar, { width: "100%", progressState: state, height: CONNECTOR_HEIGHT, transitionDelay: transitionDelay, dataTestId: "progress-bar" })))));
}
//# sourceMappingURL=ImpProgressBarItem.js.map